app.controller("exploreCtrl", [
  "$scope",
  "$location",
  "$http",
  "config",
  "$localStorage",
  "ngMeta",
  "checkUser",
  function (
    $scope,
    $location,
    $http,
    config,
    $localStorage,
    ngMeta,
    checkUser
  ) {
    if ($localStorage.microsite === undefined) {
      $localStorage.redirect = window.location.href;
      $location.path("/home");
      return {};
    }

    if (fullSite.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }
    
    ngMeta.setTitle(fullSite.shopTitle);

    var mainPlaylistID = fullSite.mainLivePlaylistID;
    var page = 1;
    var searchText = "";
    var type = "all";
    resetFilter();

    checkUser.verifyLogin(
      () => {
        getSub();
      },
      () => {
        $localStorage.redirect = window.location.href;
        $location.path("/login");
      }
    );

    $scope.changeLimit = () => {
      getSub();
    };

    $scope.search = (newSearchText) => {
      searchText = newSearchText;
      getSub();
    };

    function getSub() {
      let data = {
        subscriptionID: mainPlaylistID,
        page: page,
        limit: $scope.limit,
      };
      if (searchText != "") data.search = searchText;
      if (type != "all") data.type = type;

      $http({
        method: "POST",
        url: `${config.fstreamAPI}getSubscription`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: data,
      }).then(
        (success) => {
          $scope.sub = success.data.data;
          $scope.totalPages = success.data.totalPages;
          $scope.currentPage = success.data.page;

          if (success.data.recordsFiltered === 0) {
            $scope.position = "No results found";
          } else {
            $scope.position =
              "Showing " +
              success.data.start +
              " to " +
              success.data.finish +
              " of " +
              success.data.recordsFiltered +
              " results";
          }

          $scope.firstPage = success.data.page === 1;
          $scope.lastPage = success.data.totalPages === success.data.page;
        },
        (error) => {}
      );
    }

    function resetFilter() {
      $scope.allFilter = true;
      $scope.liveFilter = false;
      $scope.ondemandFilter = false;
      $scope.subscriptionFilter = false;
    }

    $scope.filter = function (newType) {
      type = newType;

      $scope.allFilter = type === "all";
      $scope.liveFilter = type === "live";
      $scope.ondemandFilter = type === "ondemand";
      $scope.subscriptionFilter = type === "subscription";

      getSub();
    };

    $scope.paginate = function (index) {
      page = index + 1;
      getSub();
    };

    $scope.nextPage = function () {
      page += 1;
      getSub();
    };

    $scope.previousPage = function () {
      page -= 1;
      getSub();
    };
  },
]);
